import { render } from "./QuickKeys.vue?vue&type=template&id=54fd5db8"
import script from "./QuickKeys.vue?vue&type=script&lang=js"
export * from "./QuickKeys.vue?vue&type=script&lang=js"

import "./QuickKeys.vue?vue&type=style&index=0&id=54fd5db8&lang=css"
script.render = render

export default script